import axios from 'axios';

// Token key for localStorage
const TOKEN_KEY = 'auth_token';

// Create axios instance configured for Laravel Sanctum token-based auth
const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL || 'http://localhost:8000',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// Request interceptor - add token to headers
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem(TOKEN_KEY);
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor for handling errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle 401 Unauthorized - redirect to login
        if (error.response?.status === 401) {
            // Clear local auth state
            localStorage.removeItem(TOKEN_KEY);
            sessionStorage.removeItem('authUser');
            // Optionally redirect to login
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

/**
 * Composable for API calls
 * Provides configured axios instance with token authentication
 */
export function useApi() {
    /**
     * Set auth token
     */
    const setToken = (token) => {
        if (token) {
            localStorage.setItem(TOKEN_KEY, token);
        } else {
            localStorage.removeItem(TOKEN_KEY);
        }
    };

    /**
     * Get auth token
     */
    const getToken = () => {
        return localStorage.getItem(TOKEN_KEY);
    };

    /**
     * Clear auth token
     */
    const clearToken = () => {
        localStorage.removeItem(TOKEN_KEY);
    };

    return {
        api,
        setToken,
        getToken,
        clearToken,
    };
}

export default api;
